import axios from 'axios'
import { getToken } from "../../auth/auth"
import { Stage } from '../../config/config'
import { getSiteConfig } from '../../community/siteProvider'

const getPreferencesUrl = (userId, fileName) => {
  const { siteId, libraryDrives } = getSiteConfig()
  const driveId = libraryDrives[0].driveId
  const GRAPH_API_BASE_URL = `https://graph.microsoft.com/v1.0/sites/${siteId}/drives/${driveId}/items/root:/Users/`
  const GRAPH_API_CONTENT_SUFFIX = `:/content`
  return `${GRAPH_API_BASE_URL}${userId}/${fileName}${GRAPH_API_CONTENT_SUFFIX}`
}

const getAccessToken = async () => {
  if (Stage === 'prod') {
    return (await getToken()).accessToken
  } else {
    const sessionStorageToken = window.sessionStorage.mockGraphToken
    if (sessionStorageToken) return sessionStorageToken
  }
  return undefined
}

export const getUserPreferences = async (userId, fileName) => {
  const local = window.sessionStorage.mockGraphToken
  const accessToken = local ? JSON.parse(local) : await getAccessToken()
  if (accessToken) {
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": 'application/json'
      }
    }
    const url = getPreferencesUrl(userId, fileName)
    try {
      const { data } = await axios.get(url, options)
      return data

    } catch (error) {
      if (error.response) {
        const { data, status } = error.response
        if ([403,404].includes(status)) {
          // not found or no access
          return undefined
        }
      }
      // unknown error
      throw new Error(error.message)
    }
  } else {
    // undefined, if not PROD then use mock preferences
    if (Stage === 'prod') {
      throw new Error('Could not retrieve access token')
    } else {
      // TODO use mock preferences
    }
  }
}

export const saveUserPreferences = async (userId, fileName, userPreferences, getAfterSave = false) => {
  
  // always try get first to determine proper method for save
  let method
  const existingPreferences = await getUserPreferences(userId, fileName)

  const local = window.sessionStorage.mockGraphToken
  const accessToken = local ? JSON.parse(local) : await getAccessToken()
  if (accessToken) {
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": 'application/json'
      }
    }
    const url = getPreferencesUrl(userId, fileName)
    await axios.put(url, userPreferences, options)

    if (getAfterSave) {
      return await getUserPreferences(userId, fileName)
    }

  } else {
    // undefined, if not PROD then use mock
    if (Stage === 'prod') {
      throw new Error('Could not retrieve access token')
    } else {
      if (getAfterSave) {
        return await getUserPreferences(userId, fileName)
      }
    }
  }
}

// FAVORITES preferences
const getFavoritesFileName = (group) => `${group}_favorites.json`

// GROUP CONSTANTS
export const SAFETYRESOURCES = 'SafetyResources'

export const getFavorites = async (userId, group) => {
  const groupFavoritesFileName = getFavoritesFileName(group)
  const preferences = await getUserPreferences(userId, groupFavoritesFileName)
  let favorites = []
  if (preferences) {
    favorites = preferences['favorites'] ?? []
  }
  return favorites
}


// export const saveFavoriteItem = async (userId, group, item) => {
//   let favorites = await getFavorites(userId, group)
//   if ( !favorites.includes(item)) {
//     favorites = [...favorites, item]
//     await saveUserPreferences(userId, getFavoritesFileName(group), { favorites })
//   }
//   return favorites
// }


// export const removeFavoriteItem = async (userId, group, item) => {
//   let favorites = await getFavorites(userId, group)
//   const index = favorites.indexOf(item)
//   if (index > -1) {
//     favorites.splice(index, 1);
//     await saveUserPreferences(userId, getFavoritesFileName(group), { favorites })
//   }
//   return favorites
// }


export const saveFavoriteItem = async (userId, group, item) => {
  let favorites = await getFavorites(userId, group)

  const index = favorites.findIndex(fav =>
    typeof fav === "string"
      ? fav === item.id
      : fav?.id === item.id
  )

  if (index >= 0) {
    // If current matching favorite was saved as a string, repair it
    if (typeof favorites[index] === "string") {
      favorites[index] = item
    } else {
      // Already exists as an object → nothing to do
      return favorites
    }
  } else {
    favorites = [...favorites, item]
  }

  await saveUserPreferences(
    userId,
    getFavoritesFileName(group),
    { favorites }
  )

  return favorites
}

export const removeFavoriteItem = async (userId, group, item) => {
  let favorites = await getFavorites(userId, group)

  const index = favorites.findIndex(fav =>
    typeof fav === "string"
      ? fav === item.id
      : fav?.id === item.id
  )

  if (index > -1) { 
    favorites.splice(index, 1)

    await saveUserPreferences(
      userId,
      getFavoritesFileName(group),
      { favorites }
    )
  }

  return favorites;
};